import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './plugins/pp-vue-library'
import breakpoints from '@/styles/breakpoints.scss'
import PpVueAnalytics from 'pp-vue-analytics'
import { datadogRum } from '@datadog/browser-rum'
import { Resizer } from 'sdk-widget-manager'
import { getStoredUrlParams } from 'pp-fe-utils'
import { LOCAL_STORAGE_PARAMS_KEY } from '@/constants'

Vue.use(Resizer)
Vue.config.productionTip = false

const params = getStoredUrlParams(LOCAL_STORAGE_PARAMS_KEY)

const appGaId = process.env.VUE_APP_GA_ID
const practiceGaId = params.get('gaId')
Vue.use(PpVueAnalytics, null, {
  appGaId,
  practiceGaId,
  category: 'multi-channel'
})

Vue.prototype.$ppUi = {
  isMobile: window.innerWidth < breakpoints.xs
}
Vue.prototype.$vuetify = {
  rtl: false,
  lang: {
    t: (val) => val
  },
  theme: {
    dark: false
  },
  breakpoint: {
    mobile: true,
    mobileBreakpoint: 600
  },
  icons: {
    values: {
      prev: 'mdi-chevron-left',
      next: 'mdi-chevron-right',
      dropdown: 'mdi-chevron-down',
      first: 'mdi-page-first',
      last: 'mdi-page-last',
      unfold: 'mdi-unfold-more-horizontal'
    }
  }
}

Vue.prototype.$originHost = params.get('originHost')
Vue.prototype.$practiceUuid = params.get('practiceUuid')
Vue.prototype.$ppColors = {
  primary: params.get('color_palette[primary]'),
  secondary: params.get('color_palette[secondary]'),
  accent: params.get('color_palette[accent]')
}

datadogRum.init({
  applicationId: '9222d9f5-6105-4891-b0c1-b234688c96da',
  clientToken: 'pub54dff422eae41dc4e2c0d5553a6f1c4a',
  env: process.env.VUE_APP_STAGE,
  version: process.env.VUE_APP_VERSION,
  sessionSampleRate: 50,
  sessionReplaySampleRate: 100,
  site: 'us5.datadoghq.com',
  service: 'widget-multi-channel',
  usePartitionedCrossSiteSessionCookie: true,
  trackUserInteractions: true,
  trackFrustrations: true,
  trackBfcacheViews: true,
  defaultPrivacyLevel: 'mask-user-input',
  beforeSend: (event, context) => {
    if (event.type === 'resource' && event.resource.type === 'fetch') {
      event.context = { ...event.context, responseHeaders: context.response.headers }
    }
  }
})

datadogRum.setGlobalContextProperty('practiceUuid', params.get('practiceUuid'))

datadogRum.startSessionReplayRecording()

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
